<div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'auditSampler.title' | t }}</h4>
</div>
<div class="modal-body">
    @if (formGroup) {
        <form [formGroup]="formGroup">
            <div class="row">
                <div class="col-6 left-block">
                    <div class="form-group">
                        <label>{{ 'auditSampler.sampleTypeLabel' | t }}</label>
                        <ng-select
                            bindValue="ID"
                            bindLabel="Name"
                            [items]="sampleTypes"
                            [clearable]="false"
                            [(ngModel)]="sampleModel.sampleType"
                            [ngModelOptions]="{ standalone: true }"
                        >
                        </ng-select>
                    </div>
                    <div
                        class="form-group"
                        [hidden]="sampleModel.sampleType != sampleTypeEnum.number"
                    >
                        <label>{{ 'auditSampler.testPopulationSizeLabel' | t }}</label>
                        <input
                            type="number"
                            min="1"
                            class="form-control form-control-sm"
                            formControlName="testPopulationSize"
                        />
                    </div>
                    <div class="row" [hidden]="sampleModel.sampleType != sampleTypeEnum.date">
                        <div class="form-group col">
                            <label>{{ 'auditSampler.startDateLabel' | t }}</label>
                            <date-input formControlName="startDate"></date-input>
                        </div>
                        <div class="form-group col">
                            <label>{{ 'auditSampler.endDateLabel' | t }}</label>
                            <date-input formControlName="endDate"></date-input>
                        </div>
                    </div>
                </div>
                <div class="col-6 right-block">
                    <div class="form-group">
                        <label>{{ 'auditSampler.seedNumberLabel' | t }}</label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            formControlName="seedNumber"
                        />
                    </div>
                    <div class="form-group">
                        <label>{{ 'auditSampler.numberOfTestSamplesLabel' | t }}</label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            formControlName="numberOfSamples"
                        />
                    </div>
                </div>
            </div>

            @if (allValidations.length > 0) {
                <div class="form-group-separator"></div>
                <div class="red">
                    @for (validation of allValidations; track validation.key) {
                        <p>
                            {{ validation.key | t }}
                        </p>
                    }
                </div>
            }

            @if (generatedSamples) {
                <div class="form-group-separator"></div>
                <div class="form-group">
                    <label>{{ 'auditSampler.resultLabel' | t }}</label>
                    <textarea
                        class="form-control form-control-sm"
                        readonly
                        [(ngModel)]="generatedSamples"
                        [ngModelOptions]="{ standalone: true }"
                        inputTooltip
                    ></textarea>
                </div>
            }
        </form>
    }
</div>
<div class="modal-footer">
    <button class="btn btn-cerrix" (click)="generate()" [disabled]="isGenerating">
        {{ 'auditSampler.generateBtn' | t }}
        @if (isGenerating) {
            <i class="fas fa-circle-notch fa-spin ms-2"></i>
        }
    </button>
    <button class="btn btn-dark" (click)="modalRef.hide()">{{ 'auditSampler.closeBtn' | t }}</button>
</div>
